'use client';

import { c as _c } from "react/compiler-runtime";
import { Tab } from '@common/components';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { usePathname, useSearchParams } from 'next/navigation';
import { type CSSProperties, Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { UnauthQueryOptions } from '@/api';
import { DONATION_DESKTOP_STICKY_TOP } from '@/app/donation/constants';
import { BREAKPOINTS } from '@/constants/breakpoints';
import { useCustomRouter } from '@/hooks/useCustomRouter';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import { TABS, TABS_LABELS } from '../constants';
interface DetailTabProps {
  className?: string;
  style?: CSSProperties;
  businessId: number;
}
const DetailTabComponent = t0 => {
  const $ = _c(29);
  const {
    className,
    style,
    businessId
  } = t0;
  const {
    replace
  } = useCustomRouter();
  const isDesktopViewport = useMediaQuery(BREAKPOINTS.DESKTOP, true);
  const searchParams = useSearchParams();
  const pathname = usePathname();
  let t1;
  if ($[0] !== searchParams) {
    t1 = searchParams?.get("tab") as TABS ?? TABS.BASIC;
    $[0] = searchParams;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const tab = t1;
  let t2;
  if ($[2] !== businessId) {
    t2 = UnauthQueryOptions["get:/wello/v2/allows/home/donation-business/{donationBusinessId}/detail-count"]({
      path: {
        donationBusinessId: businessId
      }
    });
    $[2] = businessId;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = {
      ...t2,
      select: _temp,
      placeholderData: keepPreviousData
    };
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const {
    data: data_0
  } = useQuery(t3);
  let t4;
  if ($[6] !== isDesktopViewport || $[7] !== style) {
    t4 = isDesktopViewport ? {
      top: DONATION_DESKTOP_STICKY_TOP
    } : style;
    $[6] = isDesktopViewport;
    $[7] = style;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = isDesktopViewport ? "lg" : "sm";
  const t6 = tab ?? TABS.BASIC;
  let t7;
  if ($[9] !== pathname || $[10] !== replace) {
    t7 = value => {
      replace(`${pathname}?tab=${value}`, {
        scroll: false
      });
    };
    $[9] = pathname;
    $[10] = replace;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Tab.Item value={TABS.BASIC}>{TABS_LABELS[TABS.BASIC]}</Tab.Item>;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== data_0?.donationCount) {
    t9 = data_0?.donationCount?.toLocaleString();
    $[13] = data_0?.donationCount;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t9) {
    t10 = <Tab.Item value={TABS.DONATIONS}>{TABS_LABELS[TABS.DONATIONS]} {t9}</Tab.Item>;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== data_0?.donationBusinessCommentCount) {
    t11 = data_0?.donationBusinessCommentCount?.toLocaleString();
    $[17] = data_0?.donationBusinessCommentCount;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t11) {
    t12 = <Tab.Item value={TABS.COMMENTS}>{TABS_LABELS[TABS.COMMENTS]}{" "}{t11}</Tab.Item>;
    $[19] = t11;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== className || $[22] !== t10 || $[23] !== t12 || $[24] !== t4 || $[25] !== t5 || $[26] !== t6 || $[27] !== t7) {
    t13 = <Tab className={className} style={t4} size={t5} variant="full" value={t6} onChange={t7}>{t8}{t10}{t12}</Tab>;
    $[21] = className;
    $[22] = t10;
    $[23] = t12;
    $[24] = t4;
    $[25] = t5;
    $[26] = t6;
    $[27] = t7;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  return t13;
};
export const DetailTab = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="h-70 border-b border-Gray-300 mobile-tablet:h-53" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <ErrorBoundary fallback={null}><Suspense fallback={t0}><DetailTabComponent {...props} /></Suspense></ErrorBoundary>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
function _temp(data) {
  return data.context;
}